export default "__VITE_ASSET__CItj0PxC__"